import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import translations from 'utils/translations';
import { useIntl } from 'react-intl';

const DiscountBox = ({ onAddDiscountTicketClick }) => {
  const intl = useIntl();
  const i18nDiscount = translations.DiscountCode(intl);
  return (
    <Box
      bgcolor={'#EEEEEE'}
      border={'1px solid #777777'}
      padding={'16px'}
      width={'100%'}
    >
      <Stack flexDirection={'row'} gap={'15px'} alignItems={'flex-start'}>
        <InfoOutlinedIcon sx={{ color: '#333333' }} fontSize="small" />
        <Stack>
          <Typography
            variant="body1-bold"
            sx={{ mb: '15px' }}
            fontFamily={'Suisse-Intl'}
            component={'p'}
          >
            {i18nDiscount.Buy.greyBox.title}
          </Typography>

          <Typography
            variant="body2"
            sx={{ mb: '25px' }}
            fontSize={'16px'}
            component={'p'}
          >
            {i18nDiscount.Buy.greyBox.subtitle}
          </Typography>
          <Typography
            variant={'link2'}
            fontWeight={400}
            color={'#333333'}
            component={'p'}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
            onClick={onAddDiscountTicketClick}
          >
            {i18nDiscount.Buy.greyBox.action}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
export default DiscountBox;
